import React, { useState, useRef, useEffect } from "react";
import  "./enanceImage.scss";
import Image from "next/image";
import Link from "next/link";

import CommingSoonModal from "@/components/modals/commingSoonModal";

import icon from "@/../public/home/enhanceimage/icon.png";
import img from "@/../public/home/enhanceimage/img.png";
import { allRoutes } from "@/data/allRoutes";


const EnhanceImage = ({ setTargetElement }) => {
  const parentRef = useRef();
  const [showCommingSoonModal, setShowCommingSoonModal] = useState(false);

  useEffect(() => {
    if (parentRef?.current) {
      setTargetElement(parentRef.current);
    }
  }, []);

  return (
    <div ref={parentRef} className="EnhanceImage">
      <div className="leftContainer">
        <p className="cursiveFont">New Age tech</p>
        <h2>AI Image Enhancer</h2>
        <strong className={`txt2 strong`}>
          Enhance low-quality images with Snapshawt AI.
        </strong>
        <p className="txt2">
          Say goodbye to blurry, low-quality images with Snapshawt&apos;s
          advanced AI technology, you can breathe new life into your favorite
          photos. Whether it&apos;s an old family snapshot, a cherished vacation
          picture, or a candid moment captured on camera, our image enhancer
          brings out the best in every image.
        </p>
        <Link href={`${allRoutes.imageEnhancer}`}>
          <button className="btn2 btn">Try Now {">"}</button>
        </Link>
      </div>

      <div className="rightContainer">
        {/* main image */}
        <div className="imgContainer">
          <Image src={img} alt="enhance-image" className="img" />
        </div>

        {/* icon */}
        <div className="iconContainer">
          <Image src={icon} alt="icon" />
        </div>
      </div>

      {/* comming soon modal */}
      {showCommingSoonModal && (
        <CommingSoonModal
          showCommingSoonModal={showCommingSoonModal}
          setShowCommingSoonModal={setShowCommingSoonModal}
        />
      )}
    </div>
  );
};

export default EnhanceImage;
